var map = {
	"./template/project/animals/desktop.svg": "796f",
	"./template/project/animals/mobile.svg": "458d",
	"./template/project/animals/tablet.svg": "e933",
	"./template/project/flu_comparison/desktop.svg": "3191",
	"./template/project/flu_comparison/mobile.svg": "3bda",
	"./template/project/flu_comparison/tablet.svg": "b7ed",
	"./template/project/sars_wuhan_comparison/desktop.svg": "19c1",
	"./template/project/sars_wuhan_comparison/mobile.svg": "e808",
	"./template/project/sars_wuhan_comparison/tablet.svg": "b7fd",
	"./template/project/surgical-mask/desktop.svg": "9c0b",
	"./template/project/surgical-mask/mobile.svg": "050b",
	"./template/project/surgical-mask/tablet.svg": "23c2",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c4a";